import { Box, Paper, Typography } from '@mui/material';

import { LocationGroupStoresGrid } from './location-group-stores-grid.component';

import { useStoresFlatLocations } from '../hooks/use-stores-flat-locations.hook';
import { ConnectionStatus } from '../retailer-network-my-stores-v2-page.types';

type StoresFlatListProps = {
  networkId: string;
  stateFilter: string;
  cityFilter: string;
  connectionStatusFilter: ConnectionStatus | '';
  search: string;
};

// Rendered instead of StoresGroupedList whenever any filter or search is active — a flat,
// paginated grid of matching locations with no group headers/"remove from group" action
// (mirrors the existing "Others" group treatment, which has no group to attribute a location to
// either). Wrapped in the same Paper/padding recipe as a location group's Accordion card
// (elevation for the white background, matching borderRadius/padding) for visual consistency.
export const StoresFlatList = ({
  networkId,
  stateFilter,
  cityFilter,
  connectionStatusFilter,
  search,
}: StoresFlatListProps) => {
  const { locations, loading, paginationProps } = useStoresFlatLocations({
    networkId,
    stateFilter,
    cityFilter,
    connectionStatusFilter,
    search,
  });

  const isInitialLoading = loading && locations.length === 0;
  const isEmpty = !loading && locations.length === 0;

  return (
    <Paper elevation={1} sx={{ borderRadius: 2, px: 3, pt: 3, pb: 1 }}>
      {isEmpty ? (
        <Box display='flex' justifyContent='center' alignItems='center' py={4}>
          <Typography color='text.secondary'>No stores match your search or filters.</Typography>
        </Box>
      ) : (
        <LocationGroupStoresGrid
          displayedLocations={locations}
          loading={loading}
          isInitialLoading={isInitialLoading}
          networkId={networkId}
          paginationProps={paginationProps}
        />
      )}
    </Paper>
  );
};
